import React, { FC } from "react";

import { ComplexConditions } from "./ComplexConditions";
import { ConditionsContainer, FilterConditionsContainer } from "../styled";

import { FeaturesFilterConditionsProps } from "../types";

export const FeaturesFilterConditions: FC<FeaturesFilterConditionsProps> = ({
  conditions,
  clearConditions,
  toggleDevMode,
  isComplex,
  children,
}) => {
  return (
    <FilterConditionsContainer>
      {isComplex && <ComplexConditions toggleDevMode={toggleDevMode} clearConditions={clearConditions} />}
      {!isComplex && (conditions?.length ?? 0) > 0 && (
        <ConditionsContainer>{conditions?.map(children)}</ConditionsContainer>
      )}
    </FilterConditionsContainer>
  );
};
